import { Instance, types } from 'mobx-state-tree';

export const ItemInfoStore = types.model('ItemInfoStore', {
  name: types.string,
  imageUrl: types.string,
  largeImageUrl: types.string,
  description: types.maybe(types.string),
  shortDescription: types.maybe(types.string),
  howToUse: types.maybe(types.string),
  partNumber: types.string,
  imageExpanded: types.optional(types.boolean, false),
  isMobile: window.innerWidth <= 576,
  pointValue: types.maybe(types.number)
});

export type ItemInfoStore = Instance<typeof ItemInfoStore>;
